import { DestroyRef, Directive, ElementRef, inject, output } from '@angular/core';

@Directive({
  selector: 'button[cueRepeatPress]',
  host: {
    '(pointerdown)': 'startPress($event)',
    '(document:pointerup)': 'endPress($event)',
    '(document:pointercancel)': 'endPress($event)',
    '(pointerleave)': 'stopPress()',
    '(window:blur)': 'stopPress()',
    '(click)': 'onClick($event)',
  },
})
export class RepeatPressDirective {
  private readonly button = inject<ElementRef<HTMLButtonElement>>(ElementRef).nativeElement;
  private pointerId: number | null = null;
  private repeatTimeout?: ReturnType<typeof setTimeout>;

  readonly cueRepeatPress = output<void>();

  constructor() {
    inject(DestroyRef).onDestroy(() => this.stopPress());
  }

  protected startPress(event: PointerEvent): void {
    if (event.button !== 0 || !event.isPrimary || this.button.disabled) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.stopPress();
    this.pointerId = event.pointerId;
    this.repeatTimeout = setTimeout(() => this.repeat(), 400);
    this.cueRepeatPress.emit();
  }

  protected endPress(event: PointerEvent): void {
    if (event.pointerId === this.pointerId) {
      this.stopPress();
    }
  }

  protected stopPress(): void {
    clearTimeout(this.repeatTimeout);
    this.repeatTimeout = undefined;
    this.pointerId = null;
  }

  protected onClick(event: MouseEvent): void {
    event.stopPropagation();
    // Pointer presses already emitted on pointerdown; keep keyboard and assistive clicks working.
    if (event.detail === 0 && !this.button.disabled) {
      this.cueRepeatPress.emit();
    }
  }

  private repeat(): void {
    if (this.pointerId === null || this.button.disabled) {
      this.stopPress();
      return;
    }

    this.repeatTimeout = setTimeout(() => this.repeat(), 400);
    this.cueRepeatPress.emit();
  }
}
